import * as React from "react";
import Header from "./Header";
import ContractLegalForm from "../contract/legal/ContractLegalForm";
import ContractLegalView from "../contract/legal/ContractLegalView";

export default function LayoutContractsLegal({ view }) {
  return (
    <>
      <Header />
      {view ? <ContractLegalView /> : <ContractLegalForm />}
    </>
  );
}
